import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { bootErrorReporter } from "./lib/errorReporter.js";

// Boot the error reporter BEFORE React. Even bundle/import errors will
// land in /clientErrors via recordClientError. The reporter swallows
// its own failures so it can never crash boot.
bootErrorReporter();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
